import { render, staticRenderFns } from "./ShareClassCreateForm.vue?vue&type=template&id=a5521dc4&"
import script from "./ShareClassCreateForm.vue?vue&type=script&lang=js&"
export * from "./ShareClassCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports